import { useCallback, useMemo, useState } from 'react';
import type { Snapshot, MarginPoint } from '../types/snapshots.ts';
import { readJSON, writeJSON } from '../lib/storage.ts';
import { appendSnapshot, toMarginSeries } from '../lib/snapshots.ts';

/** Persisted trend history for one race. Append is deduped + capped; on a quota
 *  error we drop the oldest half and retry. */
export function useSnapshots(
  raceId: string,
  cap: number,
): { snapshots: Snapshot[]; marginSeries: MarginPoint[]; append: (s: Snapshot) => void } {
  const key = `snapshots:${raceId}`;
  const [snapshots, setSnapshots] = useState<Snapshot[]>(() => readJSON<Snapshot[]>(key, []));

  const append = useCallback(
    (snap: Snapshot) => {
      setSnapshots((prev) => {
        const next = appendSnapshot(prev, snap, cap);
        if (next !== prev) {
          writeJSON(key, next, (v) => v.slice(Math.floor(v.length / 2)));
        }
        return next;
      });
    },
    [key, cap],
  );

  const marginSeries = useMemo(() => toMarginSeries(snapshots), [snapshots]);
  return { snapshots, marginSeries, append };
}
